import * as React from "react";
import styled from "styled-components";

interface ScreenContainerProps extends AppScreenProps {
  scrollRewindOnUpdate?: boolean;
}

export default class ScreenContainer extends React.Component<ScreenContainerProps> {
  static defaultProps = {
    scrollRewindOnUpdate: false
  };

  private ref: any;

  componentDidUpdate() {
    if (this.props.scrollRewindOnUpdate) {
      this.ref.scrollTop = 0;
    }
  }

  render() {
    return (
      <AppScreen visible={this.props.visible} inFront={this.props.inFront} ref={(ref: any) => (this.ref = ref)}>
        {this.props.children}
      </AppScreen>
    );
  }
}

interface AppScreenProps {
  visible: boolean;
  inFront: boolean;
}

const AppScreen = styled.div<AppScreenProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: ${({ inFront }) => (inFront ? "100" : "1")};
  overflow: scroll;
  height: 100%;
  height: ${({ visible }) => (visible ? "100%" : "0")};
  transition: none;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
`;



// WEBPACK FOOTER //
// ./src/components/Screen.tsx